import type {
  InfiniteData,
  UseInfiniteQueryResult
} from '@tanstack/react-query'
import { useCompanies } from '~/api/queries/company'
import type { WithHydraPagination } from '~/api/utils'
import type { TaxonomyItem } from '~/domains/taxonomies/types'
import type { AddressResponse } from '~/types/global'

type CompaniesAutocompleteResponse = WithHydraPagination<{
  id: number
  name: string
  companyStatus: TaxonomyItem<'company_statuses'>
  address: AddressResponse
}>

export const useCompaniesAutocomplete = ({
  ids,
  search,
  enabled = true
}: {
  ids?: string[]
  search?: string
  enabled?: boolean
}) =>
  useCompanies({
    ids,
    search,
    enabled,
    fields: ['id', 'name', 'companyStatus', 'address']
  }) as unknown as UseInfiniteQueryResult<
    InfiniteData<CompaniesAutocompleteResponse>
  >
